import { locationIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const toggleLocationReturnsCenter = unaryRpc({
  name: "toggleLocationReturnsCenter" as const,
  input: z.object({
    teamId: z.string(),
    locationId: locationIdFormat.schema,
    isReturnsCenter: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
});
